import React from "react";
import "./About.css";
import { motion } from "framer-motion";

const About = () => {
  // Parent container variants for stagger effect
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.4, // delay between each child
      },
    },
  };

  // Each line animation
  const lineVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <section id="about" className="about section-padding">

      {/* Section Header */}
      <motion.div
        className="section-header text-center"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <h2>ABOUT ME</h2>
      </motion.div>

      {/* About Content */}
      <motion.div
        className="about-container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.p className="about-text" variants={lineVariants}>
          <span className="highlight-orange">Hey!</span> I'm a Creative Developer & Designer who is passionate to build new things. Well, I'm with a focus on the MERN STACK, but still exploring other technologies and frameworks that catch my interest.
        </motion.p>

        <motion.p className="about-text" variants={lineVariants}>
          <span className="highlight-white">Ahh!</span> basically I have pursued 'Mechanical Engineering' in graduation and later on this developer role gained my focus and felt like it's my future.
        </motion.p>

        <motion.p className="about-text" variants={lineVariants}>
          I'm a fast learner who can learn new technologies in less time and always love to take challenges and new projects.
        </motion.p>

        <motion.p className="about-text" variants={lineVariants}>
          <span className="highlight-green">Yup!</span> I have Outstanding Performance on Front-End.
        </motion.p>
      </motion.div>

    </section>
  );
};

export default About;
